export default 'cyclops';
